import React from 'react'
import { connect } from 'dva'
import { framework_tool} from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool
import { templateConfig, reduxTemplateCofig } from './config'
import { modelUtils } from '@/utils'
import { handleExport } from './utils'
import column from './column';

class CertificateStatistics extends WizContainer {

    componentName = 'CertificateStatistics'

    constructor(props) {
        super(props)
        this.state = {}
    }


    _getList(nextProps, nextState, key) {
        let { code, msg } = nextProps[key]
        if (code === 1) {
            return true
        } else {
            if (msg === '品牌不能为空') {
                wizNotice.warning(msg)
            } else {
                wizNotice.error(msg)
            }
            return false
        }
    }

    _render() {
        let _reduxTemplateCofig = reduxTemplateCofig({
            templateConfig: templateConfig.call(this),
            apiDataFormat: {
                list: this._getList,
                export: handleExport.bind(this, { title: '经销商认证率统计', column })
            },
        })
        return <WizReduxTemplate {..._reduxTemplateCofig} />
    }
}

const mapStateToProps = (state, ownProps) => {
    let { certificateStatistics } = state
    const list = modelUtils.getModelEntity(certificateStatistics, 'certificateStatistics@list');
    const headList = list.data && list.data.headList
    return {
        dynamicColumns: Array.isArray(headList) && headList.length ? headList : []
    }
}

export default connect(mapStateToProps)(CertificateStatistics)
